import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=45ec7c95&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style1 from "./Users.vue?vue&type=style&index=1&id=45ec7c95&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec7c95",
  null
  
)

export default component.exports